/**
 * 简易的请求封装
 * pro版本：支持并发请求、promise封装
 * */
const isNil = require('lodash/isNil')

const URI = {
    getUserId: 'get:/demo/auth/login',
    getRoomDetail: 'post:/demo/live/room/detail',
    roomCreate: 'post:/demo/live/room/create',
    getTicket: 'post:/demo/live/apply/ticket',
    getRtcSign: 'post:/demo/live/voice/sign'
}

/**
 * @param name: 请求名称
 * @param params: 请求参数
 * */
function request (name, params) {
    if (arguments.length === 2 && typeof params === 'function') {
        params = undefined
    }
    const requestName = name
    if (isNil(URI[requestName])) throw new Error('requestName is not defined')
    const [type, relativeUrl] = (URI[requestName] || requestName).split(':')
    // const url = `https://test1-ka-vr-demo-developer.realsee.com${relativeUrl}`
    const url = `https://ka-vr-demo-developer.realsee.com${relativeUrl}`
    const result = fetch(url, {
        body: JSON.stringify(params),
        method: type?.toUpperCase()
    })
        .then(res => res.json())
        .then(res => {
            if (res.code !== 0 || !Object.keys(res.data).length) {
                throw Error(res.status)
            }
            return res.data
        })
    return result
}

export default request
